// extracted by mini-css-extract-plugin
module.exports = {"GoogleLoginButton":"GoogleLoginButton_GoogleLoginButton__1dfyp"};